import { Reducer } from 'redux';
import { EntregaNoCdState, EntregaNoCdTypes } from './types';

const INITIAL_STATE: EntregaNoCdState = {
  data: [],
  error: false,
  loading: false,
  filter: undefined,
  sorter: undefined,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<EntregaNoCdState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EntregaNoCdTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EntregaNoCdTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case EntregaNoCdTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case EntregaNoCdTypes.FILTER_ENTREGACD:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case EntregaNoCdTypes.SORTER_ENTREGACD:
      return {
        ...state,
        sorter: action.payload.sorter,
      };
    case EntregaNoCdTypes.CLEAN_ENTREGACD:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
